import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Chip, Typography } from '@mui/material';
import * as SX from './sx';
import type { PlanCellValueProps as Props } from './types';

export function PlanCellValue({ value }: Props) {
  if (value === 'check') {
    return <CheckCircleIcon sx={SX.checkIcon} />;
  }
  if (value === 'dash') {
    return (
      <Typography variant="body2" color="text.disabled">
        —
      </Typography>
    );
  }
  if (value === 'comingSoon') {
    return <Chip label="Coming Soon" size="small" sx={SX.comingSoonChip} />;
  }
  return (
    <Typography variant="body2" fontWeight={500} color="text.secondary">
      {value}
    </Typography>
  );
}
